import React from 'react'

/* Styles */
import './ConfrontationRotation.css'

/* Components */
import Rotation from '../rotation/Rotation';
import TopBar from '../topBar/TopBar';

/* Modules */
import { Breadcrumb, Select, Spin } from 'antd'
import { Link } from 'react-router-dom'

const ConfrontationRotationView = (props) => {

    let rotationList = props.rotationList.map(count => {
        return (
            <Select.Option key={count} value={count + 1}>
                Rodízio {count + 1}
            </Select.Option>
        )
    })

    return (
        <div id='champContent'>

            <TopBar />
            <div style={{ height: '70px' }}></div>

            <div className="champsBlock">
                <Breadcrumb>
                    <Breadcrumb.Item><Link to={'/home'}>Início</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs', state: { userType: props.userType } }}>
                            Campeonatos
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs/' + props.champId }}>
                            {props.champObject.nome}
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs/' + props.champId + '/confrontation' }}>
                            Confrontos
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Rodízio</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <p style={{ width: '100%', textAlign: 'center', fontSize: 'larger' }}>Confrontos dos rodízios</p>

            <div className='HomeContent'>
                {props.loadingRotationList ?
                    <Spin style={{ width: '100%', marginTop: '20px' }} />
                    :
                    <Select
                        showSearch
                        defaultValue={props.rotationId ? props.rotationId : undefined}
                        placeholder="Selecione um rodízio"
                        className='SwitchingContainerSelect'
                        optionFilterProp="children"
                        onChange={props.chooseSwitching}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        <Select.Option value={null}> </Select.Option>
                        {rotationList}
                    </Select>
                }
            </div>

            {
                props.rotationId ?
                    <Rotation
                        champObject={props.champObject}
                        champId={props.champId}
                        rotationId={props.rotationId}
                        isScoreMan={props.isScoreMan}
                    /> :
                    null
            }
        </div>
    )
}

export default ConfrontationRotationView